import FullWidthLayout from '../../layouts/FullWidthLayout';
import Container from '../../components/Container';
import MostAmazingConnectImage from '../../assets/the-most-amazing-way-to-connect.svg';
import ConnectToAnythingImage from '../../assets/connect-to-anything.svg';
import ConnectToAnythingTimelineImage from '../../assets/connect-to-anything-timeline.svg';
import PurposeOverProfitsImage from '../../assets/purpose-over-profits.svg';
import YouAreInControlImage from '../../assets/you-are-in-control.svg';
import AndFeatureDigitalIdImage from '../../assets/and-feature-digital-id.png';
import AndFeatureNewAbilitiesImage from '../../assets/and-feature-new-abilities.png';
import AndFeatureConnectToAnythingImage from '../../assets/and-feature-connect-to-anything.png';
import AndFeaturePrivacyImage from '../../assets/and-feature-privacy.png';
import Typography from '@mui/joy/Typography';
import './HomePage.css';
import EmailCaptureForm from './EmailCaptureForm';
import { Helmet } from 'react-helmet';

const Section = ({
  id = '',
  children,
  style = {},
}: {
  id?: string;
  children?: React.ReactNode;
  style?: any;
}) => {
  return (
    <section id={id} className="home__section" style={style}>
      {children}
    </section>
  );
};

const SectionImage = ({ src, alt }: { src: string; alt: string }) => {
  return <img className="home__section-img" src={src} alt={alt} />;
};

const AndFeature = ({
  imageSrc,
  text,
  description,
}: {
  imageSrc: string;
  text: string;
  description: JSX.Element | string;
}) => {
  return (
    <div className="home__feature">
      <div className={'home__feature-img'}>
        <img src={imageSrc} />
      </div>
      <Typography level="h4" sx={{ fontWeight: 600, pb: 1, color: '#6D6D6D' }}>
        {text}
      </Typography>
      <Typography>{description}</Typography>
    </div>
  );
};

const HomePage = () => {
  const videoWidth = Math.min(window.innerWidth * 0.6, 1000);
  const videoHeight = videoWidth / 1.77; // 16:9

  return (
    <FullWidthLayout>
      <Helmet>
        <link rel="canonical" href="https://andme.org" />
      </Helmet>
      <Container>
        {/* own your name */}
        <Section
          style={{
            textAlign: 'center',
            flexDirection: 'column',
            gap: 0,
            marginTop: -50,
            // marginBottom: 100,
          }}
        >
          <div className="home__hero">
            <iframe
              title="& connect with anything"
              className="home__video"
              src="https://player.vimeo.com/video/769942700?h=99610e8332&byline=false&title=false&title=false&portrait=false"
              frameBorder="0"
              allow="autoplay; fullscreen"
              allowFullScreen
              width={videoWidth}
              height={videoHeight}
            ></iframe>
          </div>
          {/* TODO: replace email CTA with search after beta launch */}
          {/* <h1 className="smoothed">own your name</h1>
            <p className="home__hero__subtitle">across every platform + the real world</p> */}
          {/*
               TODO: search icon
               TODO: replace email CTA with search after beta launch
             */}
          {/* <input
              type="text" id="search" name="search" className={"home__search"}
              placeholder={"get your &tag"}
              value={tag}
              onChange={(e) => setTag(e.currentTarget.value)}
            /> */}
          <EmailCaptureForm />
        </Section>
      </Container>

      <Container>
        {/* TODO: this is hidden until we start to actually sell tags to people.  */}
        {/* just claimed */}
        {/* <Wrapper>
          <Section>
            <div style={styles.textContainer}>
              <h2>{"Just Claimed"}</h2>
              <p>Here are a few premium &tags that have just been claimed.  Check if the ones you want are still available!</p>
            </div>
            <div
              style={{
                background: '#FFFFFF',
                boxShadow: '0px 4px 114px rgba(0, 0, 0, 0.1)',
                borderRadius: 10,
              }}
            >
              <SectionImage
                src={JustClaimedTableImage}
                alt={"Just claimed table"}
              ></SectionImage>
            </div>
          </Section>
        </Wrapper> */}

        {/* amazing way to connect! */}
        <Section
          id="hero"
          style={{
            marginTop: 100,
          }}
        >
          <SectionImage
            src={MostAmazingConnectImage}
            alt="The most amazing way to connect"
          />
          <div style={styles.textContainer}>
            <Typography level="h1">The Most Amazing Way to Connect</Typography>
            <Typography>
              Connecting is simple, powerful and private. In the app,{' '}
              <b>
                just tap the <span className="and-logo">&</span> button to
                connect with anyone
              </b>{' '}
              - even if they don't have the app.
            </Typography>
            <br />
            <Typography>
              <b>Connect on your terms.</b> Just pick the relationship.{' '}
              <span className="and-logo">&</span> ensures you have the right
              contact info, social networks and essential tools at your
              fingertips.
            </Typography>
          </div>
        </Section>

        {/* & features */}
        <Section
          id="whatsinanand"
          style={{
            textAlign: 'center',
            flexDirection: 'column',
            marginTop: 100,
          }}
        >
          <Typography level="h1" sx={{ lineHeight: 1.2 }}>
            What's in an{' '}
            <span
              className="and-logo"
              style={{
                padding: '0.4rem 1rem',
              }}
            >
              &
            </span>
            ?
          </Typography>
          <div className={'home__features'}>
            <AndFeature
              imageSrc={AndFeatureDigitalIdImage}
              text={'Own Your Identity'}
              description={
                <>
                  Identity is individual. Define who you are, on your own terms,
                  with <span className="and-logo">&</span>. Pick an <b>&tag</b>{' '}
                  to use and share everywhere.
                </>
              }
            />
            <AndFeature
              imageSrc={AndFeatureConnectToAnythingImage}
              text={'Connect With More'}
              description={
                <>
                  Connect with people and places. As{' '}
                  <span className="and-logo">&</span> grows, discover new and
                  exciting things to connect with.
                </>
              }
            />
            <AndFeature
              imageSrc={AndFeatureNewAbilitiesImage}
              text={'Gain New Abilities'}
              description={
                'Empower your social life: chat, plan events, and gain new abilities like sensing, beaming, and social location.'
              }
            />
            <AndFeature
              imageSrc={AndFeaturePrivacyImage}
              text={'Be More'}
              description={
                'Embrace your authentic self with ease, as your privacy and personal rights are inherently protected.'
              }
            />
          </div>
        </Section>

        {/* Connect to anything */}
        <Section
          id="connecttoanything"
          style={{
            marginTop: 100,
          }}
        >
          <div style={styles.textContainer}>
            <Typography level="h1">{'Connect to Anything'}</Typography>
            <Typography>
              Your <span className="and-logo">&</span> can already help you{' '}
              <b>connect with people and places.</b> Over time it will connect
              to much more. This is just the beginning of our mission to help
              you connect with anything - <b>on your terms.</b>
            </Typography>
          </div>
          <SectionImage
            src={ConnectToAnythingImage}
            alt={'Just claimed table'}
          ></SectionImage>
        </Section>
        <div>
          <img
            src={ConnectToAnythingTimelineImage}
            className="hide-mobile"
            style={{
              width: '100%',
            }}
          />
        </div>

        {/* purpose over profits */}
        <Section
          id="purposeoverprofits"
          style={{
            marginTop: 150,
          }}
        >
          <SectionImage
            src={PurposeOverProfitsImage}
            alt="Purpose over profits"
          />
          <div style={styles.textContainer}>
            <Typography level="h1">Purpose Over Profits</Typography>
            <Typography>
              <b>
                <span className="and-logo">&</span> doesn't have ads
              </b>
              , and <b>you control your data</b>. When you choose to connect
              with a business and share info with them, we charge the business
              for the tools they need to securely, privately interact with you.
            </Typography>
            <br />
            <Typography>
              We also make money if you buy a premium <b>&tag</b>.
            </Typography>
            <br />
            <Typography>
              That's it.{' '}
              <b>
                We think of money as fuel for our purpose, and not the other way
                around.
              </b>
            </Typography>
          </div>
        </Section>

        {/* You're in control */}
        <Section
          id="youreincontrol"
          style={{
            marginTop: 200,
          }}
        >
          <div style={styles.textContainer}>
            <Typography level="h1">You're in Control</Typography>
            <Typography>
              We believe you should <b>own and control your identity.</b> So we
              build simple tools to help you do that.
            </Typography>
            <br />
            <Typography>
              Over time, we plan to decentralize more and more of our platform -
              starting now by minting{' '}
              <b>an NFT on XRPL that proves you own your &tag.</b>
            </Typography>
            <br />
            <Typography>
              Don't know what any of that means? Don't worry - we do all the
              heavy lifting for you. Just know that{' '}
              <b>
                we believe the most equitable way forward is with individuals in
                control
              </b>
              , and not big institutions - not even ours.
            </Typography>
          </div>
          <SectionImage src={YouAreInControlImage} alt="You are in control" />
        </Section>

        {/* &'s purpose */}
        <Section>
          <div
            className={'marketing-jumbo-card'}
            style={{
              marginTop: 300,
              maxWidth: '90vw',
            }}
            id="purpose"
          >
            <Typography
              level="h2"
              sx={{ color: 'var(--and-palette-text-tertiary)' }}
            >
              <span className="and-logo" style={{ padding: '.5rem 1rem' }}>
                &
              </span>
              ’s Purpose
            </Typography>
            <Typography level="h1" variant="jumbo">
              Move the world toward <b>joy</b>
            </Typography>
          </div>
        </Section>

        <Section
          style={{
            marginTop: 300,
            textAlign: 'center',
            flexDirection: 'column',
            gap: 0,
          }}
        >
          <EmailCaptureForm />
        </Section>
      </Container>
    </FullWidthLayout>
  );
};

const styles = {
  textContainer: {
    maxWidth: 500,
  },
};

export default HomePage;
